import { ValidationInterface } from '../../validation.interface';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import { Partnership, PartnershipPropName } from '../../../../models/project/financial/financial-investment/partnership.model';

export class PartnershipValidation implements ValidationInterface {
  /** The current partnership obj that is being validated */
  private readonly partnership: Partnership;

  /**
   * Sets the partnership obj that will be used for validation
   * @param partnership will be used to set the current partnership obj
   */
  constructor(partnership: Partnership) {
    if (!partnership) throw Error('invalid partnership provided for validation');
    this.partnership = new Partnership(partnership);
  }

  /**
   * Get a validation unit containing the validation data for the current value obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.partnership) throw Error('unable to validate partnership');
    const validationUnit = new ProjectValidationUnit();
       if (this.partnership.name) {
         validationUnit.setValid(PartnershipPropName.Name);
       } else {
         validationUnit.setInvalid(PartnershipPropName.Name, [PartnershipError.MissingName]);
       }

       if (this.partnership.investmentContribution) {
         validationUnit.addModuleResults(
           new UnitValueValidation(this.partnership.investmentContribution).getValidation(),
           PartnershipPropName.InvestmentContribution
         );
       }

       if (this.partnership.netIncomeShare) {
         validationUnit.addModuleResults(
           new UnitValueValidation(this.partnership.netIncomeShare).getValidation(),
           PartnershipPropName.NetIncomeShare
         );
       }

    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current partnership obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}

/**
 * An enum that contains error that relate to partnership errors
 */
export enum PartnershipError {
  MissingName = 'VALIDATION.MISSING_NAME'
}
